import { useEffect, useEffectEvent } from 'react';

import { ORIGIN } from '#src/config.ts';
import { safeUrlSearchParams } from '#src/lib/urls.ts';

const SCA_MESSAGE = 'sorare:mangopay:sca-complete';

type Props = {
  onSuccess: () => void;
  onFailed: () => void;
};

export const MangopayScaPopupCallback = ({ onSuccess, onFailed }: Props) => {
  const postMessageCb = (location: string) => {
    const params = safeUrlSearchParams(location);
    if (!params) return;
    const controlStatus = params.get('controlStatus');
    if (controlStatus) {
      if (controlStatus === 'VALIDATED') {
        onSuccess();
      } else if (controlStatus === 'REFUSED' || controlStatus === 'FAILED') {
        onFailed();
      }
    }
  };

  const latestPostMessageCallback = useEffectEvent(postMessageCb);

  useEffect(() => {
    const cb = (event: MessageEvent) => {
      if (event.origin !== ORIGIN) return;
      if (event.data.eventId === SCA_MESSAGE) {
        latestPostMessageCallback(event.data.data.location);
      }
    };
    window.addEventListener('message', cb);

    return () => window.removeEventListener('message', cb);
  }, []);

  return null;
};
